/**
 * Convenience aliases for the auto-generated Supabase types.
 *
 * Use these in hooks instead of hand-writing row interfaces:
 *
 *   import type { Row, Insert, Update, RpcReturn } from '../lib/db-types'
 *   type Template = Row<'templates'>
 *   type TemplateInsert = Insert<'templates'>
 *   type MemberRow = RpcReturn<'get_team_members'>[number]
 *
 * When the schema changes, regenerate with `npm run types:gen` and any
 * stale column references become compile errors instead of runtime 500s.
 */
import type { Database, Json } from './database.types'

/**
 * Re-export so callers don't need to import from two places.
 */
export type { Json }

/**
 * Cast a typed value to `Json` for RPC payloads. The generated `Json`
 * type is intentionally strict (recursive + index signature), which makes
 * it hard to satisfy from concrete shapes like `MyRow[]`. Use this at RPC
 * call sites where you're confident the value is JSON-serialisable:
 *
 *   supabase.rpc('upsert_contacts', { payload: asJson(rows) })
 *
 * It's a type-only cast — no runtime cost. Runtime JSON safety is the
 * caller's responsibility.
 */
export const asJson = <T>(value: T): Json => value as unknown as Json

type PublicSchema = Database['public']

export type Row<T extends keyof PublicSchema['Tables']> =
  PublicSchema['Tables'][T]['Row']

export type Insert<T extends keyof PublicSchema['Tables']> =
  PublicSchema['Tables'][T]['Insert']

export type Update<T extends keyof PublicSchema['Tables']> =
  PublicSchema['Tables'][T]['Update']

export type RpcArgs<F extends keyof PublicSchema['Functions']> =
  PublicSchema['Functions'][F]['Args']

export type RpcReturn<F extends keyof PublicSchema['Functions']> =
  PublicSchema['Functions'][F]['Returns']

export type ViewRow<V extends keyof PublicSchema['Views']> =
  PublicSchema['Views'][V]['Row']
